import { FaHome, FaCar, FaTractor, FaFolderOpen } from "react-icons/fa";
import emlakImg from "images/categories/emlak.png";
import vasitaImg from "images/categories/vasita.png";
import isMakineleriImg from "images/categories/is-makineleri.png";

// Kategori başına belirgin vektör ikon + marka rengi. Backend'deki küçük,
// birbirine benzeyen `category.icon` görsellerinin yerine ana sayfada
// kullanılır. Eşleştirme slug VEYA isim üzerinden (Türkçe karakterler
// normalize edilerek) yapılır; böylece slug/isim değişse de tutarlı kalır.

// "Vasıta" -> "vasita", "İş Makineleri" -> "is makineleri"
function normalizeKey(value) {
  return (value || "")
    .toLocaleLowerCase("tr")
    .replace(/ı/g, "i")
    .replace(/ş/g, "s")
    .replace(/ğ/g, "g")
    .replace(/ü/g, "u")
    .replace(/ö/g, "o")
    .replace(/ç/g, "c")
    .trim();
}

// `image`: müşterinin tasarımındaki gibi yuvarlak fotoğraf. Temiz bir kare
// görsel `src/images/categories/` altına konup buraya import edilince kart
// otomatik fotoğraf moduna geçer; yokken belirgin vektör ikon gösterilir.
const PRESETS = [
  {
    match: ["makine"],
    Icon: FaTractor,
    color: "#E8870B",
    subtitle: "Kepçe • Vinç • Forklift • Dozer",
    image: isMakineleriImg,
  },
  {
    match: ["vasita", "arac", "vehicle", "oto"],
    Icon: FaCar,
    color: "#2F6FED",
    subtitle: "Otomobil • Arazi • Motosiklet",
    image: vasitaImg,
  },
  {
    match: ["emlak", "konut", "gayrimenkul"],
    Icon: FaHome,
    color: "#16A571",
    subtitle: "Konut • Arsa • İşyeri",
    image: emlakImg,
  },
];

// { Icon, color, tint, subtitle, image } döndürür. Bilinmeyen kategori için
// klasör ikonu + kategorinin kendi rengi (yoksa marka yeşili) ile güvenli
// fallback; alt başlık/fotoğraf bilinmeyen kategoride boştur.
export function getCategoryVisual(category) {
  const key = `${normalizeKey(category && category.slug)} ${normalizeKey(
    category && category.name
  )}`;

  const preset = PRESETS.find((p) => p.match.some((m) => key.includes(m)));
  const color = (preset && preset.color) || (category && category.color) || "#11986e";
  const Icon = (preset && preset.Icon) || FaFolderOpen;

  return {
    Icon,
    color,
    tint: `${color}1a`,
    subtitle: (preset && preset.subtitle) || "",
    image: (preset && preset.image) || null,
  };
}
